import escapeHTML from 'escape-html'

// Handle server & client
function setTitle(title) {
  // Update title in $ssrContext
  if (this && this.$vnode && this.$ssrContext) {
    this.$ssrContext.title = escapeHTML(title) // escape for HTML usage
  }

  // Update title in dom
  if (typeof document !== 'undefined') {
    document.title = title
  }
}

// Handle server only
function setMeta(meta) {
  if (this && this.$vnode && this.$ssrContext) {
    let handledMeta = []
    if (Array.isArray(meta)) {
      handledMeta = meta.map(item => {
        const escapeItem = {}
        Object.keys(item).forEach(key => {
          escapeItem[key] = escapeHTML(item[key])
        })
        return escapeItem
      })
    } else {
      console.warn('[Launcher $setMeta] Object-based meta was deprecated, please use Array-based meta instead and read the UPGRADE-GUIDE.md ') // eslint-disable-line no-console

      for (const key in meta) {// eslint-disable-line
        const escapeItem = {}
        if (key && meta[key]) {
          escapeItem.name = key
          escapeItem.content = escapeHTML(meta[key]) // escape for HTML attribute usage
        }
        handledMeta.push(escapeItem)
      }
    }

    this.$ssrContext.meta = handledMeta
  }
}

export default function initHead(app, Launcher) {
  // Set title after entering any route for client
  if (Launcher.isBrowser) {
    app.router.afterEach(to => {
      if (to.meta && to.meta.title) {
        setTitle(to.meta.title)
      }
    })
  }

  // Set $setTitle method
  app.vm.config.globalProperties.$setTitle = setTitle

  // Set $setMeta method
  app.vm.config.globalProperties.$setMeta = setMeta
}
